import React from 'react';

import { Tooltip, useMediaQuery, useTheme } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { Icon, IconClose } from '../IconSet';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'inline-flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: theme.spacing(1),
    },
    title: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    icons: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(1),
    },
  })
);


type Props = {
  onClose: () => void;
  title: string;
  disableFullScreen?: boolean;
  forceFullScreen?: boolean;
  help?: string | JSX.Element;
  helpIcon?: string;
};


function ClosableDialog(props: Props & DialogProps) {
  const classes = useStyles();

  const {
    title,
    onClose,
    disableFullScreen = false,
    forceFullScreen = false,
    help,
    helpIcon,
    children,
    ...rest
  } = props;

  const theme = useTheme();
  const shouldGoFullscreen = useMediaQuery(theme.breakpoints.down('xs'));
  const useFullScreen = (!disableFullScreen && shouldGoFullscreen) || forceFullScreen;

  return (
    <Dialog fullScreen={useFullScreen} onClose={onClose} {...rest}>
      <DialogTitle disableTypography className={classes.content}>
        <Typography className={classes.title} variant="h6">
          { title }
        </Typography>
        <div className={classes.icons}>
          { help && helpIcon &&
            <Tooltip title={help}>
              <div>
                <Icon icon={helpIcon} color={grey[500]} size={24} />
              </div>
            </Tooltip>
          }
          <IconButton onClick={onClose}>
            <IconClose color={grey[500]} size={24} />
          </IconButton>
        </div>
      </DialogTitle>
      {children}
    </Dialog>
  );
}


export default ClosableDialog;
